import React, { createContext, useState, useEffect } from 'react';

export const ChatContext = createContext();

export const ChatProvider = ({ children }) => {
  const [messages, setMessages] = useState([]);
  const [streamMessage, setStream] = useState("");
  const [isSending, setIsSending] = useState(false);
  const [isReceiving, setIsReceiving] = useState(false);
  const [error, setError] = useState(null);
  const [streamFailed, setStreamFailed] = useState(false);
  const [status, setStatus] = useState(null);
  const [statusType, setStatusType] = useState(null);

   // Initialize state from local storage
   useEffect(() => {
    const storedMessages = localStorage.getItem('messages');
    if (storedMessages) {
      try {
        const parsedMessages = JSON.parse(storedMessages);
        if (Array.isArray(parsedMessages)) {
          setMessages(parsedMessages);
        } else {
          localStorage.setItem('messages', JSON.stringify([]));
          setMessages([]);
        }
      } catch (error) {
        console.error("Failed to parse stored messages:", error);
        localStorage.setItem('messages', JSON.stringify([]));
        setMessages([]);
      }
    } else {
      localStorage.setItem('messages', JSON.stringify([]));
      setMessages([]);
    }
  }, []);

  // Sync state to local storage whenever messages change
  useEffect(() => {
    if (Array.isArray(messages)) {
      localStorage.setItem('messages', JSON.stringify(messages));
    }
  }, [messages]);

  const addToMessages = message => {
    setIsSending(true);
    setMessages(prevMessages => {
      if (Array.isArray(prevMessages)) {
        return [...prevMessages, message];
      } else {
        return [message];
      }
    });
    setIsSending(false);
  };

  const addToStreamMessage = chunk => {
    if (chunk === null) {
      setStream("");
      return;
    }
    setStream(prevStream => prevStream + chunk);
  };

  const setStatusMessage = (message, type) => {
    setStatus(message);
    setStatusType(type);
  };

  const value = {
    messages,
    setMessages,
    streamMessage,
    addToStreamMessage,
    addToMessages,
    error,
    setError,
    streamFailed,
    setStreamFailed,
    status,
    statusType,
    setStatusMessage,
  };

  return (
    <ChatContext.Provider value={value}>
      {children}
    </ChatContext.Provider>
  );
};
